import React, { useEffect, useState } from 'react';

const TransparencySlider = ({ globalState, globalRefs, mapRef }) => {
  const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  const globalPolygonTransparency = globalState.globalPolygonTransparency;
  const setGlobalPolygonTransparency = globalState.setGlobalPolygonTransparency;
  const multuGroupSelectedArray = globalState.multuGroupSelectedArray;

  useEffect(() => {
    if (polygonCustomLayerRef.current) {
      polygonCustomLayerRef.current.setTransparency(globalPolygonTransparency);
    }
  }, [globalPolygonTransparency]);

  useEffect(() => {
    if(multuGroupSelectedArray.length === 0){
      setGlobalPolygonTransparency(1);
    }
  }, [multuGroupSelectedArray])

  const handleTransparencyChange = (e) => {
    const value = e.target.value;
    const normalized = value / 100;

    setGlobalPolygonTransparency(normalized);

    if (polygonCustomLayerRef.current) {
      polygonCustomLayerRef.current.setTransparency(normalized);
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '230px',
        left: '17.5%',
        width: '65%',
        height: '50px',
        backgroundColor: '#fff',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          marginBottom: '0px',
          fontSize: '10px',
        }}
      >
        <b>Transparency:</b>
      </div>
      <input
        type="range"
        min="0"
        max="100"
        value={globalPolygonTransparency * 100}
        onChange={handleTransparencyChange}
        style={{
          width: '100%',
        }}
      />
    </div>
  );
};

export default TransparencySlider;